export default __webpack_public_path__ + "static/media/remove-cutout.e01b7768.svg";